export default __webpack_public_path__ + "static/media/foto.37c3de63.jpg";